// extracted by mini-css-extract-plugin
export default {"aside":"AsideRight_aside__EbcMV","aside__max":"AsideRight_aside__max__+ON4a","aside__min":"AsideRight_aside__min__Zs3NM"};